import React from 'react'
import { Link } from 'react-router-dom'
import InsurerSystemsDirectory from '../components/InsurerSystemsDirectory'

const WORKFLOW_TILES = [
  {
    to: '/requests/new',
    title: '설계 의뢰',
    accent: 'border-brand-navy bg-brand-navy text-white hover:opacity-95',
  },
  {
    to: '/counterparts',
    title: '원수사 담당자',
    accent: 'border-slate-200 bg-white text-slate-900 hover:border-brand-navy/25 hover:bg-slate-50',
  },
  {
    to: '/work/policy-lookup',
    title: '약관 조회',
    accent: 'border-slate-200 bg-white text-slate-900 hover:border-brand-navy/25 hover:bg-slate-50',
  },
  {
    to: '/terms-library',
    title: '약관 라이브러리',
    accent: 'border-slate-200 bg-white text-slate-900 hover:border-brand-navy/25 hover:bg-slate-50',
  },
  {
    to: '/data/insurers',
    title: '원수사 마스터',
    accent: 'border-slate-200 bg-white text-slate-900 hover:border-brand-navy/25 hover:bg-slate-50',
  },
  {
    to: '/support/claims',
    title: '보험금 청구',
    accent: 'border-slate-200 bg-white text-slate-900 hover:border-brand-navy/25 hover:bg-slate-50',
  },
  {
    to: '/ops/forms/claims/templates',
    title: '청구 서식(운영)',
    accent: 'border-slate-200 bg-white text-slate-900 hover:border-brand-navy/25 hover:bg-slate-50',
  },
  {
    to: '/ops/stats/claims',
    title: '청구 통계',
    accent: 'border-slate-200 bg-white text-slate-900 hover:border-brand-navy/25 hover:bg-slate-50',
  },
]

function WorkflowGrid() {
  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
      {WORKFLOW_TILES.map((t) => (
        <Link
          key={t.to}
          to={t.to}
          className={`group flex flex-col rounded-2xl border p-4 shadow-sm transition ${t.accent}`}
        >
          <div className="text-sm font-bold">{t.title}</div>
          <div className={`mt-3 text-[11px] font-semibold uppercase tracking-wide ${t.title === '설계 의뢰' ? 'text-white/90' : 'text-brand-navy opacity-0 transition group-hover:opacity-100'}`}>
            이동 →
          </div>
        </Link>
      ))}
    </div>
  )
}

/**
 * 운영자 전용: 원수사 업무를 한 랜딩에서 이어갈 수 있도록 내부 메뉴 + 보험사 전산 동일 목록을 제공합니다.
 */
export default function InsurerBusinessHubPage() {
  return (
    <div className="mx-auto max-w-[1400px] space-y-8 px-4 py-8">
      <header className="space-y-2 border-b border-slate-200 pb-6">
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">운영자 · 업무 허브</div>
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <h1 className="text-2xl font-bold tracking-tight text-slate-900">보험사 업무 허브</h1>
          </div>
          <Link
            to="/work/insurer-systems"
            className="shrink-0 rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-800 hover:bg-slate-50"
          >
            전산 전용 화면만
          </Link>
        </div>
      </header>

      <section className="space-y-3">
        <h2 className="text-sm font-bold uppercase tracking-wide text-slate-500">업무 바로가기</h2>
        <WorkflowGrid />
      </section>

      <section className="space-y-3">
        <h2 className="text-sm font-bold uppercase tracking-wide text-slate-500">원수사 연결</h2>
        <InsurerSystemsDirectory variant="hub" />
      </section>
    </div>
  )
}
